module.exports = __webpack_public_path__ + "img/zhuanpan.6d4c34f1.png";